export default (dir) => {
    if (dir === 'rtl') {
        document.getElementById('semantic-rtl').removeAttribute('disabled');
        document.getElementById('semantic').setAttribute('disabled', true);
    } else {
        document.getElementById('semantic-rtl').setAttribute('disabled', true);
        document.getElementById('semantic').removeAttribute('disabled');
    }
};